
export class AdminResponseDto {
  requestId:string;
  response:boolean;
  userEmail:string;
  serviceId:number;
};

export class UserResponseDto{
  requestId:string;
  response:number;
  userName:string;
  serviceId:number;
  UserRejectionReasons:string;
  UserRequiredModifications:string;
}
